<div class="container-fluid my-5">
	<div class="row">
	  <div id="produtos" class="col-md-12">
		  <h2 class="mb-5">Política de Privacidade</h2>
		  <p class="content" [innerHTML]="policy$ | async"></p>
	  </div>
	</div>
</div>
